import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import PageLoader from '../../components/feedback/PageLoader';
import {
  probeLoyaltySessionAndRedirect,
} from '../../utils/loyaltyEarlyAuth';

/**
 * Smart entry for table QR codes (/loyalty). Validates session after load,
 * then routes to profile or the login form without a full-page reload.
 */
export default function LoyaltyProgramEntry() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let mounted = true;

    (async () => {
      const user = await probeLoyaltySessionAndRedirect(location.search);
      if (!mounted) return;

      if (user) {
        return;
      }

      navigate(`/loyalty/login${location.search || ''}`, { replace: true });
    })();

    return () => {
      mounted = false;
    };
  }, [navigate, location.search]);

  return <PageLoader minHeight="100vh" />;
}
